import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Scadenza } from '../../../models/scadenza';
import { SezioneScadenze } from '../../../models/sezioni/sezione-scadenze';
import { ScadenzaUpdateConcreteFormComponent } from './scadenza-update-concrete-form.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
  selector: 'div [modale_modifica_scadenza]',
  templateUrl: 'scadenza-mod-modify.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ScadenzaModModifyComponent {
  @Output() onReturn: EventEmitter<SezioneScadenze> = new EventEmitter<SezioneScadenze>();
  @Output() scadenzaMod: EventEmitter<Scadenza> = new EventEmitter<Scadenza>();
  @ViewChild('formScadenzario') formScadenzario: ScadenzaUpdateConcreteFormComponent;

  inizializza(urlUpdate: string, scadenza: Scadenza, idSezione: string, fascicoloGeneric: string, idFascicolo:string) {
    this.formScadenzario.inizializza(urlUpdate, scadenza, idSezione, fascicoloGeneric, idFascicolo);
    openModal('modalmodifyscad');
  }

  createForm() {
    this.formScadenzario.createForm();
  }

  manageModal(sezione: SezioneScadenze) {
    if (sezione) {
      closeModal('modalmodifyscad');
      this.onReturn.emit(sezione);
    }
  }
  getScadenzaMod(scadenzaMod: Scadenza){
    this.scadenzaMod.emit(scadenzaMod);
  }
}
